import requestv2 from "~/utils/http-v2";
const serviceToDoApi = {
	gets : async (params) => {
		const url = 'v2/service/todo';
		return await requestv2.get(url, {params});
	},
	add : async (params) => {
		const url = `v2/service/todo`;
		return await requestv2.post(url, params);
	},
	addDomain : async (params) => {
		const url = `v2/service/todo/domain`;
		return await requestv2.post(url, params);
	},
	status : async (params) => {
		const url = `v2/service/todo/status`;
		return await requestv2.post(url, params);
	},
	finished : async (params) => {
		const url = `v2/service/todo/finished`;
		return await requestv2.post(url, params);
	},
	update : async (params) => {
		const url = `v2/service/todo/${params.id}`;
		return await requestv2.patch(url, params);
	},
	delete : async (id) => {
		const url = `v2/service/todo/${id}`;
		return await requestv2.delete(url);
	}
};

export default serviceToDoApi;